import React from 'react'

import {
  Route,
  Redirect
} from 'react-router-dom'

import { isAuthenticated } from 'utils/auth'
import { reverse } from 'routes'


export const AuthRequiredRoute = ({ render, ...routeProps}) => {
  const _render = (props) => {
    return !isAuthenticated() ? (
      <Redirect to={{
        pathname: reverse('accounts:login'),
        state: { from: props.location }
      }}/>
    ) : render(props)
  }

  return <Route {...routeProps} render={_render}/>
}



// WEBPACK FOOTER //
// ./src/utils/router.js